var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-page" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "make-invoice-step-one-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: _vm.$selectByLang(
              "1050px",
              "1070px",
              "1070px",
              "1270px",
              "1170px",
              "1170px"
            ),
            "close-on-click-modal": false,
            "show-close": false,
            top: "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-top": "0" }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("90px", "110px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.invoice_invoicingMethod")
                          }
                        },
                        [
                          _c("span", { staticStyle: { "font-size": "14px" } }, [
                            _vm._v(_vm._s(_vm.invoicingMethod))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            attrs: {
                              slot: "label",
                              label: _vm.isCollectInvoice
                                ? _vm.$t("Invoice.invoice_CollectInvoiceType")
                                : _vm.$t("Invoice.invoice_invoicingType")
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "custom-radio-group",
                              attrs: { no: "typeGroup" },
                              model: {
                                value: _vm.properties.typeGroup,
                                callback: function($$v) {
                                  _vm.$set(_vm.properties, "typeGroup", $$v)
                                },
                                expression: "properties.typeGroup"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "multi",
                                    disabled: _vm.properties.isHedge
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCollectInvoice
                                        ? _vm.$t(
                                            "Invoice.invoice_consolidatedInvoiceCollect"
                                          )
                                        : _vm.$t(
                                            "Invoice.invoice_consolidatedInvoice"
                                          )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "settlementAgent",
                                    disabled:
                                      _vm.properties.isHedge ||
                                      _vm.properties.toExoSystemHC
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCollectInvoice
                                        ? _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToSettlementAgentCollect"
                                          )
                                        : _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToSettlementAgent"
                                          )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "job",
                                    disabled:
                                      _vm.properties.isHedge ||
                                      _vm.properties.toExoSystemHC
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCollectInvoice
                                        ? _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToBusinessCollect"
                                          )
                                        : _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToBusiness"
                                          )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: "single",
                                    disabled:
                                      _vm.properties.isHedge ||
                                      (_vm.properties.toExoSystemHC &&
                                        !_vm.properties.isAr)
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isCollectInvoice
                                        ? _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToRecordsCollect"
                                          )
                                        : _vm.$t(
                                            "Invoice.invoice_invoicingAccordingToRecords"
                                          )
                                    )
                                  )
                                ]
                              ),
                              _vm.shouldShowTitleOption()
                                ? _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: "title",
                                        disabled: _vm.properties.isHedge
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isCollectInvoice
                                            ? _vm.$t(
                                                "Invoice.invoice_invoicingAccordingToTitleCollect"
                                              )
                                            : _vm.$t(
                                                "Invoice.invoice_invoicingAccordingToTitle"
                                              )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Invoice.invoice_makeType") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "groupingMakeType" },
                              on: { change: _vm.changeInvoiceType },
                              model: {
                                value: _vm.properties.groupingMakeType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.properties,
                                    "groupingMakeType",
                                    $$v
                                  )
                                },
                                expression: "properties.groupingMakeType"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: 0,
                                    disabled:
                                      _vm.properties.invoiceType === 6 ||
                                      _vm.properties.invoiceType === 7 ||
                                      _vm.properties.isEasyInoivceVietnam
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Invoice.invoice_makePaper"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    label: 1,
                                    disabled:
                                      _vm.properties.invoiceType !== 2 &&
                                      _vm.properties.invoiceType !== 3
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Invoice.invoice_makeElectronic")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.invoice_invoiceType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "175px" },
                              attrs: { no: "invoiceType" },
                              on: { change: _vm.invoiceTypeChange },
                              model: {
                                value: _vm.properties.invoiceType,
                                callback: function($$v) {
                                  _vm.$set(_vm.properties, "invoiceType", $$v)
                                },
                                expression: "properties.invoiceType"
                              }
                            },
                            _vm._l(_vm.invoiceTypeOptions, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.properties.invoiceType === 6 ||
                      _vm.properties.invoiceType === 7
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Invoice.SpecificConstraintTypes")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "175px" },
                                  attrs: { disabled: _vm.restrictionHC },
                                  model: {
                                    value:
                                      _vm.properties.specificConstraintType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.properties,
                                        "specificConstraintType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "properties.specificConstraintType"
                                  }
                                },
                                _vm._l(
                                  _vm.InvoiceConstant.SPECIFIC_CONSTRAINT_TYPES,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            attrs: {
                              slot: "label",
                              label: _vm.isCollectInvoice
                                ? _vm.$t(
                                    "Invoice.invoice_invoicingAccordingToCurrencyCollect"
                                  )
                                : _vm.$t(
                                    "Invoice.invoice_invoicingAccordingToCurrency"
                                  )
                            },
                            slot: "label"
                          }),
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "currencyGroup" },
                              model: {
                                value: _vm.properties.currencyGroup,
                                callback: function($$v) {
                                  _vm.$set(_vm.properties, "currencyGroup", $$v)
                                },
                                expression: "properties.currencyGroup"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "inlineWarp",
                                  staticStyle: { "margin-bottom": "10px" }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        no: "invoicingPerCurrency",
                                        label: 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isCollectInvoice
                                            ? _vm.$t(
                                                "Invoice.invoice_invoicingPerCurrencyCollect"
                                              )
                                            : _vm.$t(
                                                "Invoice.invoice_invoicingPerCurrency"
                                              )
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.properties.currencyGroup === 1,
                                        no: "cbAssignCurrency"
                                      },
                                      model: {
                                        value: _vm.properties.cbAssignCurrency,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.properties,
                                            "cbAssignCurrency",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "properties.cbAssignCurrency"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_specifyInvoiceCurrency"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              !_vm.properties.settlementCenterMode
                                ? _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        no: "consolidatedCurrency",
                                        label: 1,
                                        disabled:
                                          _vm.properties.isEasyInoivceVietnam
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Invoice.invoice_consolidatedCurrency"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            attrs: {
                              slot: "label",
                              label: _vm.isCollectInvoice
                                ? _vm.$t(
                                    "Invoice.invoice_invoicingCurrencyCollect"
                                  )
                                : _vm.$t("Invoice.invoice_invoicingCurrency")
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "175px" },
                            attrs: {
                              no: "currency",
                              filterable: "",
                              "select-type": _vm.TYPE_NAMES.basic_data_Currency,
                              "default-value": _vm.properties.currency,
                              clearable: false,
                              disabled:
                                _vm.properties.allowModifyCurrency === false ||
                                !(
                                  (_vm.properties.currencyGroup === 0 &&
                                    _vm.properties.cbAssignCurrency) ||
                                  _vm.properties.currencyGroup === 1
                                )
                            },
                            on: { parentCallBack: _vm.currencyChangeEvent }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            attrs: {
                              slot: "label",
                              label: _vm.$t(
                                "Invoice.invoice_settleDepartmentPrefix"
                              )
                            },
                            slot: "label"
                          }),
                          _c("cargo-department-select", {
                            staticStyle: { width: "175px" },
                            attrs: {
                              no: "settleDepartment",
                              "office-id": Number(
                                _vm.$store.getters.currentOfficeId
                              ),
                              "department-id": Number(
                                _vm.properties.settleDepartment
                              )
                            },
                            on: { change: _vm.settleDepartmentChangeEvent }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticStyle: { width: "640px" } }, [
                _c("div", { staticClass: "app-main-inner-row" }, [
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_InvoiceItemNameSetup"))
                    )
                  ])
                ]),
                _vm.viewSource !== "overseaBilling" &&
                _vm.viewSource !== "internalBillInfo"
                  ? _c("div", { staticClass: "app-main-inner-row" }, [
                      _c(
                        "div",
                        { staticClass: "triggers" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", no: "toAdd" },
                              on: { click: _vm.toAdd }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "toEdit",
                                disabled: _vm.isEditing
                              },
                              on: { click: _vm.toEdit }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                no: "toDelete",
                                disabled: _vm.isEditing
                              },
                              on: { click: _vm.toDelete }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                          ),
                          _c(
                            "el-button",
                            {
                              style: _vm.$selectByLang("", "margin-top: 5px;"),
                              attrs: {
                                type: "primary",
                                no: "doDefaultSetting",
                                disabled: _vm.isEditing
                              },
                              on: { click: _vm.doDefaultSetting }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_SetDefaultItemDescription"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "needSave",
                                disabled: !_vm.needSave
                              },
                              on: { click: _vm.toSave }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                          ),
                          _vm.properties.isEasyInoivceVietnam
                            ? _c(
                                "el-dropdown",
                                {
                                  staticStyle: { "padding-left": "5px" },
                                  attrs: {
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.btnSetupHandler()
                                    },
                                    command: function(p) {
                                      _vm.commandCode = p
                                      _vm.btnSetupHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(" " + _vm._s(_vm.commandCode) + " "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceChargeItemSetup"
                                            ),
                                            no: "invoiceChargeItemSetup"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_InvoiceChargeItemSetup"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceChargeUnitSetup"
                                            ),
                                            no: "invoiceChargeUnitSetup"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_InvoiceChargeUnitSetup"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "app-main-inner-row row-grid",
                    staticStyle: {
                      height: "260px",
                      "padding-left": "10px",
                      "padding-right": "6px"
                    }
                  },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "100%", flex: "1" },
                      attrs: {
                        "config-module": "20220416",
                        "grid-params": _vm.invoiceGoodsName.gridParams,
                        "grid-options": _vm.invoiceGoodsName.gridOptions,
                        "column-defs": _vm.invoiceGoodsNameColumnDefs,
                        "row-data": _vm.invoiceGoodsNameRowData
                      },
                      on: {
                        "update:gridParams": function($event) {
                          return _vm.$set(
                            _vm.invoiceGoodsName,
                            "gridParams",
                            $event
                          )
                        },
                        "update:grid-params": function($event) {
                          return _vm.$set(
                            _vm.invoiceGoodsName,
                            "gridParams",
                            $event
                          )
                        },
                        gridReady: function(params) {
                          return (_vm.gridApi = params.api)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "red",
                      "padding-left": "10px",
                      "padding-right": "6px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TaxRevenueToolTip")))]
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                width: "100%",
                "flex-wrap": "wrap"
              },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    flex: "1",
                    "flex-wrap": "wrap",
                    "padding-right": "10px",
                    "font-size": "13px"
                  }
                },
                [
                  _c("span", {
                    staticStyle: { "margin-right": "4px" },
                    domProps: {
                      textContent: _vm._s(_vm.$t("Invoice.invoice_total"))
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-right": "4px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.totalDisplayText))]
                  ),
                  _vm.reCalc
                    ? _c("charge-currency-total-group", {
                        key: 3,
                        staticStyle: { display: "none" },
                        attrs: {
                          mode: "group",
                          type: "revenueAbs",
                          "data-field": "amount",
                          "rate-field": "invoiceRate",
                          "currency-field": "currency",
                          source: "invoiceDetail",
                          "ar-field": _vm.arField,
                          "data-provider": _vm.invoiceCharges,
                          "amount-to-currency": _vm.properties.currency,
                          "currency-conversion-in-invoices":
                            _vm.currencyConversionInInvoices
                        },
                        on: { callback: _vm.onTotalCallback }
                      })
                    : _vm._e(),
                  _vm.properties.txtCurrency1 !== ""
                    ? [
                        _c("span", { staticStyle: { "margin-left": "12px" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.invoice_currency")) + " "
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.properties.txtCurrency1)),
                            _c("i", { staticClass: "el-icon-right" }),
                            _vm._v(_vm._s(_vm.properties.currency))
                          ])
                        ]),
                        _c("span", { staticStyle: { "margin-left": "8px" } }, [
                          _vm._v(_vm._s(_vm.$t("Invoice.invoice_exchangeRate")))
                        ]),
                        _c("num-input", {
                          staticStyle: { width: "95px" },
                          attrs: {
                            no: "txtRate1",
                            precision: 8,
                            "truncated-precision": _vm.txtRate1Precision
                          },
                          on: { change: _vm.txtRate1Change },
                          model: {
                            value: _vm.properties.txtRate1,
                            callback: function($$v) {
                              _vm.$set(_vm.properties, "txtRate1", $$v)
                            },
                            expression: "properties.txtRate1"
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm.properties.txtCurrency2 !== ""
                    ? [
                        _c("span", { staticStyle: { "margin-left": "12px" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("Invoice.invoice_currency")) + " "
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.properties.txtCurrency2)),
                            _c("i", { staticClass: "el-icon-right" }),
                            _vm._v(_vm._s(_vm.properties.currency))
                          ])
                        ]),
                        _c("span", { staticStyle: { "margin-left": "8px" } }, [
                          _vm._v(_vm._s(_vm.$t("Invoice.invoice_exchangeRate")))
                        ]),
                        _c("num-input", {
                          staticStyle: { width: "95px" },
                          attrs: {
                            no: "txtRate2",
                            precision: 8,
                            "truncated-precision": _vm.txtRate2Precision
                          },
                          on: { change: _vm.txtRate2Change },
                          model: {
                            value: _vm.properties.txtRate2,
                            callback: function($$v) {
                              _vm.$set(_vm.properties, "txtRate2", $$v)
                            },
                            expression: "properties.txtRate2"
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "autoSplitCharge", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.prepareChargeSplit("auto")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Invoice.AutoSplitCharge")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "splitCharge", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.prepareChargeSplit("manual")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Sp31")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "btnCancel" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "invoice_next", type: "primary" },
                      on: { click: _vm.toNext }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Invoice.invoice_invoiceConfirmation"))
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.maintainDialog.show,
            title: _vm.maintainDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.maintainDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.maintainDialog.maintainForm,
                "label-width": "140px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.InvoiceType") } },
                    [_c("el-select")],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.RMBExpenseItemName") } },
                    [_c("el-input")],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.USDExpenseItem") } },
                    [_c("el-input")],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.TaxRate") } },
                    [_c("el-input")],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c("el-checkbox", [
                        _vm._v(_vm._s(_vm.$t("Clearing.DefaultItemName")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.doSave }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.maintainDialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.invoiceChargeItemDialog.visible
        ? _c("invoice-charge-item-window", {
            attrs: {
              visible: _vm.invoiceChargeItemDialog.visible,
              "invoice-type": _vm.properties.invoiceType
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoiceChargeItemDialog, "visible", $event)
              },
              close: function($event) {
                _vm.invoiceChargeItemDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.invoiceChargeUnitDialog.visible
        ? _c("invoice-charge-unit-window", {
            attrs: {
              visible: _vm.invoiceChargeUnitDialog.visible,
              "invoice-type": _vm.properties.invoiceType
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoiceChargeUnitDialog, "visible", $event)
              },
              close: function($event) {
                _vm.invoiceChargeUnitDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.splitChargeSelectDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_PleaseSelectExpenseToSplit"),
            width: "760px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.splitChargeSelectDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.splitChargeSelectDialog.rowData,
                height: "320",
                "highlight-current-row": ""
              },
              on: {
                "current-change": function(row) {
                  _vm.splitChargeSelectDialog.currentRow = row
                },
                "row-dblclick": function(row) {
                  _vm.splitChargeSelectDialog.currentRow = row
                  _vm.confirmChargeSplitSelection()
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "jobNo",
                  label: _vm.$t("Invoice.invoice_businessNumber"),
                  width: "160"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "chargeName",
                  label: _vm.$t("CargoMsg.Cargo_ChargeName"),
                  "min-width": "160"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currency",
                  label: _vm.$t("CargoMsg.Cargo_Currency"),
                  width: "90"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: _vm.$t("Invoice.invoice_taxIncludedPrice"),
                  width: "120"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "taxRate",
                  label: _vm.$t("Invoice.billingJob_taxRate"),
                  width: "90"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "ok", type: "primary" },
                  on: { click: _vm.confirmChargeSplitSelection }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.splitChargeSelectDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-step-two-split-charge-dialog",
          attrs: {
            visible: _vm.splitChargeDialog.show,
            title: _vm.$t("CargoMsg.Cargo_Sp31"),
            width: "760px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.splitChargeDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.splitChargeDialog.splitChargeForm,
                "label-width": "70px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.chargeName))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.currency))
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.splitChargeDialog.charge.amount))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_SplitExpenseP") }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.chargeName)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.splitChargeDialog.splitCharge.currency)
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "amount",
                          precision: 2,
                          "controls-position": "right",
                          controls: false
                        },
                        on: { change: _vm.amountChangeHandler },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.amount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "amount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_TaxExcludedPriceP")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "excludingTaxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value:
                            _vm.splitChargeDialog.splitCharge
                              .excludingTaxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "excludingTaxAmount",
                              $$v
                            )
                          },
                          expression:
                            "splitChargeDialog.splitCharge.excludingTaxAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c("el-form-item", { attrs: { label: " " } }),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxAmountP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxAmount",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxAmount",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom-form-item-w",
                      attrs: { label: _vm.$t("CargoMsg.Cargo_TaxRateP") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "taxRate",
                          precision: 2,
                          min: -99999999,
                          max: 99999999,
                          "controls-position": "right",
                          disabled: true
                        },
                        model: {
                          value: _vm.splitChargeDialog.splitCharge.taxRate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.splitChargeDialog.splitCharge,
                              "taxRate",
                              $$v
                            )
                          },
                          expression: "splitChargeDialog.splitCharge.taxRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    left: "0",
                    "padding-left": "10px"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "onlyChangeQuantity" },
                      on: { change: _vm.onlyChangeQuantityChangeHandler },
                      model: {
                        value: _vm.splitChargeDialog.onlyChangeQuantity,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.splitChargeDialog,
                            "onlyChangeQuantity",
                            $$v
                          )
                        },
                        expression: "splitChargeDialog.onlyChangeQuantity"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Invoice.invoice_SplitChargeOnlyChangeQuantity"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "ok",
                    type: "primary",
                    disabled: _vm.splitChargeDialog.btnSplitEnable
                  },
                  on: { click: _vm.doSplitCharge }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.splitChargeDialog.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.autoSplitChargeDialog.visible,
            title: _vm.$t("Invoice.AutoSplitCharge"),
            width: "630px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.autoSplitChargeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.autoSplitChargeDialog.chargeOrigin,
                "label-width": "90px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #000000",
                    height: "100px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin
                                  .chargeName
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.currency
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TaxIncludedPriceP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.amount
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SplitExpenseP")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin
                                  .chargeName
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.autoSplitChargeDialog.chargeOrigin.currency
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.IncludingTaxAmountLimit")
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              precision: 2,
                              "controls-position": "right",
                              controls: false
                            },
                            on: {
                              change: function(p) {
                                _vm.autoSplitChargeDialog.confirmSplitEnable = true
                                _vm.maxAmountChangeHandler(p)
                              }
                            },
                            model: {
                              value: _vm.autoSplitChargeDialog.maxAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.autoSplitChargeDialog,
                                  "maxAmount",
                                  $$v
                                )
                              },
                              expression: "autoSplitChargeDialog.maxAmount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-bottom": "10px", float: "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "toAutoCalculateSplit",
                            type: "primary"
                          },
                          on: { click: _vm.toAutoCalculateSplit }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.AutoCalculateSplit")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { "min-height": "310px" } },
                [
                  _c("h1", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(_vm._s(_vm.$t("Invoice.AutoCalculateSplitResult")))
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginalExpenseP")
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.autoSplitChargeDialog.chargeOrigin.chargeName
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_CurrencyP") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.autoSplitChargeDialog.chargeOrigin.currency
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "section grid-wrapper",
                      staticStyle: { "min-height": "200px" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-options": _vm.autoSplitChargeDialog.gridOptions,
                          "column-defs": _vm.autoSplitChargeDialog.columnDefs,
                          "row-data": _vm.autoSplitChargeDialog.rowData,
                          "check-main-record": false,
                          "deselect-main-record": false,
                          "auto-fit-content": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.autoSplitChargeDialog.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { float: "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            no: "doAutoSplitCharge",
                            disabled:
                              _vm.autoSplitChargeDialog.confirmSplitEnable
                          },
                          on: { click: _vm.doAutoSplitCharge }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "autoSplitChargeDialogCancel" },
                          on: {
                            click: function($event) {
                              _vm.autoSplitChargeDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "res-data": _vm.batchCheckingWindow.resData,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }